import { useCallback } from "react";
import { ref, set, remove } from "firebase/database";
import { db } from "../api/firebase";
import { useAuth } from "../helpers/Auth";
import { useNavigate } from "react-router";
import uuid from "react-uuid";

const useFiringActions = () => {
  const { effectiveUID } = useAuth();
  const navigate = useNavigate();

  const userPath = () => `/userdata/${effectiveUID}`;

  const createFiring = useCallback(
    (formProps: any, allowNavigate: boolean = true) => {
      if (!formProps.id) {
        formProps.id = uuid();
      }
      const newProps = { ...formProps };
      if (newProps?.date?.getMonth) {
        newProps.date = newProps.date.getTime();
      }

      set(ref(db, userPath() + `/firings/${formProps.id}`), {
        ...newProps,
      });
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  const editFiring = useCallback(
    (id: string, formProps: any, allowNavigate: boolean = true) => {
      const newProps = { ...formProps };
      newProps.id = id;
      if (newProps.notes === "") {
        delete newProps.notes;
      }
      if (newProps?.date?.getMonth) {
        newProps.date = newProps.date.getTime();
      }

      set(ref(db, userPath() + `/firings/${id}`), {
        ...newProps,
      });
      if (allowNavigate) {
        navigate(-1);
      }
    },
    [effectiveUID, navigate]
  );

  const deleteFiring = useCallback(
    (id: string, allowNavigate: boolean = true) => {
      remove(ref(db, userPath() + `/firings/${id}`));
      if (allowNavigate) {
        navigate("/projects");
      }
    },
    [effectiveUID, navigate]
  );

  return { createFiring, editFiring, deleteFiring };
};

export default useFiringActions;
